<template>
    <div class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">{{ route.params.id ? 'Editar Categoria de Plano' : 'Nova Categoria de Plano' }}</h4>
        <button class="btn btn-secondary btn-sm me-3" @click="voltar">Voltar</button>
      </div>
  
      <BaseForm :isFormValid="isFormValid" :isSubmitting="isSubmitting" @submit="salvarCategoria" @cancel="voltar">
        <!-- Dados da Categoria -->
        <FormSection title="Informações da Categoria">
          <InputField
            v-model="categoria.nome"
            label="Nome da Categoria <span class='required'>*</span>"
            id="nome"
            placeholder="Digite o nome da categoria"
            required
            :class="{ 'error-input': errors.nome }"
            width="500px"            
          />
  
          <div class="form-group">
            <label for="ativo">Status <span class="required">*</span></label>
            <div class="form-switch">
                <input
                type="checkbox"
                id="ativo"
                v-model="categoria.ativo"
                class="form-check-input"
                />
                <label for="ativo" class="form-check-label">
                {{ categoria.ativo ? "Ativo" : "Inativo" }}
                </label>
            </div>
          </div>
        </FormSection>
      </BaseForm>
    </div>
  </template>
        
<script>
  import { reactive, ref, computed, onMounted } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import InputField from '@/components/Layout/InputField.vue';
  import FormSection from '@/components/Layout/FormSection.vue';
  import BaseForm from '@/components/Layout/BaseForm.vue';
  import axios from '@/services/axios';
  
  export default {
  components: { InputField, FormSection, BaseForm },
  setup() {
      const route = useRoute();
      const router = useRouter();

      const categoria = reactive({
          id: null,
          nome: "",
          ativo: true, // Valor padrão para o status
      });

      const errors = reactive({});
      const formTouched = ref(false);
      const isSubmitting = ref(false);

      const validateForm = () => {
      errors.nome = categoria.nome ? '' : 'O nome da categoria é obrigatório.';
      };

      const isFormValid = computed(() => {
      return categoria.nome.trim() !== '' && !Object.values(errors).some((error) => error);
      });

      const novaCategoria = () => {
      formTouched.value = false;
      isSubmitting.value = false;
      Object.assign(categoria, {
          nome: '',
          ativo: true,
      });
      for (const key in errors) {
          if (Object.hasOwn(errors, key)) errors[key] = '';
      }
      };

      const salvarCategoria = async () => {
          if (isSubmitting.value) return;

          validateForm();

          if (!isFormValid.value) {
              console.error("O formulário contém erros:", errors);
              return;
          }

          isSubmitting.value = true;
          try {
              const method = categoria.id ? "put" : "post";
              const url = categoria.id
              ? `/cadastros/categorias-de-planos/${categoria.id}`
              : "/cadastros/categorias-de-planos";

              await axios[method](url, {
              nome: categoria.nome,
              ativo: categoria.ativo, // Inclui o valor do status
              });

              router.push("/cadastros/categorias-de-planos");
          } catch (error) {
              console.error("Erro ao salvar categoria:", error);
          } finally {
              isSubmitting.value = false;
          }
      };

      const voltar = () => {
      router.push('/cadastros/categorias-de-planos');
      };

      onMounted(async () => {
      const categoriaId = route.params.id;

      if (categoriaId) {
          try {
          const response = await axios.get(`/cadastros/categorias-de-planos/${categoriaId}`);
          Object.assign(categoria, response.data);
          } catch (error) {
          console.error('Erro ao carregar categoria:', error);
          }
      } else {
          novaCategoria();
      }
      });

      return {
      categoria,
      errors,
      isFormValid,
      formTouched,
      isSubmitting,
      salvarCategoria,
      voltar,
      route, // Inclua o objeto route aqui
      };
  },
  };
</script>
      
<style scoped>
  .card {
    max-width: 90%;
    margin: 0 auto;
  }
  
  .error-input {
    border-color: #dc3545;
  }
  
  .error-message {
    color: #dc3545;
    font-size: 0.875rem;
  }
  .form-switch {
  display: flex;
  align-items: center;
  gap: 10px;
}

</style>
  